module.exports = __webpack_public_path__ + "img/star_yellow.9b0709aa.svg";